'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularRoute = require('angular-route');

var _angularRoute2 = _interopRequireDefault(_angularRoute);

var _angularAnimate = require('angular-animate');

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularSanitize = require('angular-sanitize');

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularCookies = require('angular-cookies');

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularLocalStorage = require('angular-local-storage');

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _angularLoadingBar = require('angular-loading-bar');

var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);

var _angularResource = require('angular-resource');

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ngIpsumSrcIpsum = require('ng-ipsum/src/ipsum');

var _ngIpsumSrcIpsum2 = _interopRequireDefault(_ngIpsumSrcIpsum);

var _angularStrap = require('angular-strap');

var _angularStrap2 = _interopRequireDefault(_angularStrap);

//import ngTable from 'ng-table';

var moduleName = 'app.core';

exports['default'] = _angular2['default'].module(moduleName, ['ngRoute', 'ngAnimate', 'ngSanitize', 'ngCookies', 'LocalStorageModule', 'angular-loading-bar', 'ngResource', 'ipsum', 'mgcrea.ngStrap']);
module.exports = exports['default'];

//'ngTable',


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/app.core.js
 ** module id = 13
 ** module chunks = 0
 **/